module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "line-numbered-textarea-wrapper"
  }, [_c('label', {
    staticClass: "titleized",
    attrs: {
      "for": "contacts_textarea"
    }
  }, [_vm._v(_vm._s(_vm.$t('contacts_group.label.insertInfo')))]), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.has_line_errors),
      expression: "has_line_errors"
    }],
    staticClass: "line-numbered-textarea-errors error-message"
  }, _vm._l((_vm.line_errors), function(errors_with_line_number) {
    return _c('div', {
      staticClass: "line-numbered-textarea-line-error"
    }, [(errors_with_line_number.line_number) ? _c('div', {
      staticClass: "line-error-number"
    }, [_vm._v(_vm._s(errors_with_line_number.line_number))]) : _vm._e(), _vm._l((errors_with_line_number.errors), function(error) {
      return (errors_with_line_number.line_number) ? _c('div', {
        staticClass: "line-error-error"
      }, [_vm._v(_vm._s(error))]) : _vm._e()
    })], 2)
  }), 0)]), _c('div', {
    staticClass: "contacts-text-area-label"
  }, [_c('span', {
    staticClass: "number textarea-label"
  }, [_vm._v("N°")]), _c('span', {
    staticClass: "fields textarea-label"
  }, [_vm._v(_vm._s(_vm.attributes))])]), _c('div', [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.contact_list),
      expression: "contact_list"
    }],
    staticClass: "lined",
    attrs: {
      "placeholder": _vm.attributes,
      "name": "contacts_textarea"
    },
    domProps: {
      "value": (_vm.contact_list)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.contact_list = $event.target.value
      }, _vm.validateUnlessPristine]
    }
  })])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-26d6dcb6!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/contacts/picker/text_csv.vue
// module id = 1053
// module chunks = 1